function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import EventSetter from "../EventSetter";
import { Popper } from "../Popper";
import ThemeContext from "../ThemeProvider/ThemeContext";
import { injectTestId } from "@cvent/nucleus-test-automation";
import Magazine from "../Magazine";
import Portal from "../Portal";
var Menu = function(_param) {
    var ariaLabelledby = _param.ariaLabelledby, dangerouslySetStateOpen = _param.dangerouslySetStateOpen, id = _param.id, _isRtl = _param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl, maxHeight = _param.maxHeight, _minWidth = _param.minWidth, minWidth = _minWidth === void 0 ? 176 : _minWidth, onClose = _param.onClose, onSelect = _param.onSelect, options = _param.options, _placement = _param.placement, placement = _placement === void 0 ? 'bottom-start' : _placement, _popperjsModifiers = _param.popperjsModifiers, popperjsModifiers = _popperjsModifiers === void 0 ? [] : _popperjsModifiers, portal = _param.portal, selected = _param.selected, _shouldCloseOnMissing = _param.shouldCloseOnMissing, shouldCloseOnMissing = _shouldCloseOnMissing === void 0 ? false : _shouldCloseOnMissing, testID = _param.testID, transitionProps = _param.transitionProps, trigger = _param.trigger, zIndex = _param.zIndex, rest = _objectWithoutProperties(_param, [
        "ariaLabelledby",
        "dangerouslySetStateOpen",
        "id",
        "isRtl",
        "maxHeight",
        "minWidth",
        "onClose",
        "onSelect",
        "options",
        "placement",
        "popperjsModifiers",
        "portal",
        "selected",
        "shouldCloseOnMissing",
        "testID",
        "transitionProps",
        "trigger",
        "zIndex"
    ]);
    var theme = useContext(ThemeContext);
    var ref2 = _slicedToArray(useState(dangerouslySetStateOpen || false), 2), isOpen1 = ref2[0], setIsOpen = ref2[1];
    var containerRef = useRef(null);
    var popperRef = useRef(null);
    var triggerRef = useRef(null);
    var triggerContainerRef = useRef(null);
    var handleTargetClick = function() {
        return setIsOpen(function(isOpen) {
            return !isOpen;
        });
    };
    var handleClose = useCallback(function() {
        var ref;
        setIsOpen(false);
        if (typeof (triggerRef === null || triggerRef === void 0 ? void 0 : (ref = triggerRef.current) === null || ref === void 0 ? void 0 : ref.focus) !== 'undefined') {
            triggerRef.current.focus();
        }
        if (onClose) {
            onClose();
        }
    }, [
        setIsOpen,
        onClose
    ]);
    useEffect(function() {
        var handleOutsideClick = function(event) {
            var ref;
            var target = event.target;
            if (isOpen1 && _instanceof(target, HTMLElement) && !((ref = ReactDOM.findDOMNode(containerRef.current)) === null || ref === void 0 ? void 0 : ref.contains(target))) {
                handleClose();
            }
        };
        window.addEventListener('click', handleOutsideClick, false);
        return function() {
            return window.removeEventListener('click', handleOutsideClick, false);
        };
    }, []);
    var ref1;
    return _jsxs("div", _objectSpread({}, injectTestId(testID), {
        children: [
            _jsx("div", {
                ref: triggerContainerRef,
                children: trigger(handleTargetClick, isOpen1, triggerRef)
            }),
            _jsx(Portal, {
                portal: portal,
                children: _jsx(Popper, {
                    animationFunction: "productive",
                    flip: true,
                    isOpen: isOpen1,
                    isRtl: isRtl,
                    placement: placement,
                    popperjsModifiers: _toConsumableArray(popperjsModifiers).concat([
                        {
                            name: 'offset',
                            enabled: true,
                            options: {
                                offset: [
                                    0,
                                    8
                                ]
                            }
                        }
                    ]),
                    popperRef: popperRef,
                    transitionProps: transitionProps,
                    triggerRef: (triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) ? triggerRef : triggerContainerRef,
                    zIndex: zIndex,
                    children: _jsx(EventSetter, {
                        containerRef: containerRef,
                        onDismiss: handleClose,
                        shouldDismissOnMissing: shouldCloseOnMissing,
                        children: _jsx("div", {
                            ref: containerRef,
                            children: _jsx(Magazine, {
                                "aria-labelledby": (ref1 = rest === null || rest === void 0 ? void 0 : rest['aria-labelledby']) !== null && ref1 !== void 0 ? ref1 : ariaLabelledby,
                                focusOnMount: true,
                                handleClose: handleClose,
                                id: id,
                                isRtl: isRtl,
                                magazineStyleObject: {
                                    position: 'relative',
                                    maxWidth: '18rem',
                                    maxHeight: maxHeight,
                                    minWidth: minWidth,
                                    width: 'max-content',
                                    padding: "".concat(theme.spacing[3], " 0")
                                },
                                onUpdate: onSelect,
                                options: options,
                                selected: selected,
                                testID: testID,
                                theme: theme,
                                zIndex: zIndex
                            })
                        })
                    })
                })
            })
        ]
    }));
};
export { Menu };
export default Menu;
